import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { COLORS_ADMIN_PAGE } from '../../../conf/constants';
import { Municipality } from '../../../administration/type';

interface AssignedMunicipalityListProps {
  municipalities: Municipality[];
  selectedMunicipalities: number[];
  onSelectMunicipality: (id: number) => void;
}

const AssignedMunicipalityList: React.FC<AssignedMunicipalityListProps> = ({
  municipalities,
  selectedMunicipalities,
  onSelectMunicipality
}) => {
  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={{ height: '56px', mb: 2 }} />
      
      <Droppable droppableId="assigned">
        {(provided) => (
          <Paper
            {...provided.droppableProps}
            ref={provided.innerRef}
            sx={{
              height: 400,
              p: 0,
              bgcolor: COLORS_ADMIN_PAGE.WHITE,
              borderRadius: 1,
              border: `1px solid ${COLORS_ADMIN_PAGE.BORDER}`,
              overflowY: 'auto',
              boxShadow: 'none'
            }}
          >
            <Box sx={{ p: 2 }}>
              {municipalities.length === 0 ? (
                <Typography variant="body2" sx={{
                  color: COLORS_ADMIN_PAGE.TEXT_SECONDARY,
                  fontStyle: 'italic'
                }}>
                  No municipalities selected
                </Typography>
              ) : (
                municipalities.map((municipality, index) => (
                  <Draggable key={municipality.id} draggableId={municipality.id.toString()} index={index}>
                    {(provided, snapshot) => (
                      <Box
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        sx={{
                          display: 'block',
                          py: 2,
                          px: 4,
                          fontSize: '14px',
                          mb: 1,
                          cursor: 'pointer',
                          borderRadius: 1,
                          bgcolor: selectedMunicipalities.includes(municipality.id)
                            ? COLORS_ADMIN_PAGE.PRIMARY
                            : COLORS_ADMIN_PAGE.LIGHT_GRAY,
                          color: selectedMunicipalities.includes(municipality.id)
                            ? COLORS_ADMIN_PAGE.WHITE
                            : COLORS_ADMIN_PAGE.BLACK,
                          opacity: snapshot.isDragging ? 0.8 : 1,
                          transform: snapshot.isDragging ? 'rotate(5deg)' : 'none',
                          '&:hover': {
                            bgcolor: selectedMunicipalities.includes(municipality.id)
                              ? COLORS_ADMIN_PAGE.PRIMARY
                              : COLORS_ADMIN_PAGE.BACKGROUND,
                          },
                        }}
                        onClick={() => onSelectMunicipality(municipality.id)}
                      >
                        {municipality.name + ' - ' + municipality.province.name}
                      </Box>
                    )}
                  </Draggable>
                ))
              )}
              {provided.placeholder}
            </Box>
          </Paper>
        )}
      </Droppable>
      
      <Box sx={{ height: '56px', mt: 2 }} />
    </Box>
  );
};

export default AssignedMunicipalityList;